export const set   = (layout)  => ({ type: 'SET_LAYOUT', payload: layout });

export default (dispatch) => {
	return {
        set   : (layout)   => dispatch(set(layout)),
    }
};